import { BreakoutRoomEntries } from 'features/breakout-rooms/types';
import { translateBreakoutDefaultRoomName } from 'features/breakout-rooms/utils/translateBreakoutDefaultRoomName';

// Translates room names based on the original name property
// This ensures breakout rooms are properly localized when language changes
export const localizeBreakoutRoomNames = (
  roomEntries: BreakoutRoomEntries
): BreakoutRoomEntries => {
  const localizedRooms: BreakoutRoomEntries = {};

  for (const [id, room] of Object.entries(roomEntries)) {
    localizedRooms[id] = { ...room };
    if (room.originalName) {
      localizedRooms[id].name = translateBreakoutDefaultRoomName(room.originalName);
    }
  }

  return localizedRooms;
};
